import React from "react";

import "./index.css";

const SectionHeader = ({ children }) => {
  return (
    <div className="section-header">
      <span>{children}</span>
    </div>
  );
};

export default SectionHeader;
